import React, { useEffect } from 'react';
import { useAuthStore } from '@/core/auth/auth.store';
import { Footer } from '@/shared/components/layout/Footer';

const ExpiredLinkPage = () => {
    const { resetUser } = useAuthStore();

    // Página terminal: limpiar user para no arrastrar datos a una próxima sesión SSO.
    useEffect(() => {
        resetUser();
        sessionStorage.removeItem('vitalsProfile');
    }, [resetUser]);

    return (
        <>
            <div className="container-vitals">
                <section className="section-vitals form-vitals m-3">
                    <div className="title-vitals mb-3">
                        <i className="icon icon_enlinea_excluido"></i>
                        El enlace ya no está disponible
                    </div>

                    <div className="text-vitals-left">
                        <ul>
                            <li className="mb-3">
                                Si ya realizaste tu chequeo, este enlace ya no se<br />
                                encuentra vigente.
                            </li>
                            <li>
                                Si no lo hiciste en el tiempo establecido, puedes<br />
                                contactarnos para solicitar un nuevo acceso.
                            </li>
                        </ul>
                    </div>
                </section>
            </div>

            <Footer/>
        </>
    );
};

export { ExpiredLinkPage };